export default __webpack_public_path__ + "static/media/020-falling rocks.9f4df857.png";